import AVATAR_IMG from "@/assets/icons/avatar.svg";
import LOGOUT_ICON from "@/assets/icons/logout.svg";
import useAuth from "@/hooks/useAuth";
import "./style.scss";

const UserInfo = () => {
  const { logout, auth } = useAuth();

  return (
    <div className="user-info-section">
      <img
        src={
          auth.photo
            ? `${process.env.REACT_APP_API_URL}/file/${auth.photo}`
            : AVATAR_IMG
        }
        alt="user-profile-pic"
      />
      <div className="user-info">
        <span className="info-name">{auth.fullName}</span>
        <span className="info-email">{auth.email}</span>
      </div>
      <div className="btn-logout" onClick={logout}>
        <img src={LOGOUT_ICON} alt="logout-icon" />
      </div>
    </div>
  );
};

export default UserInfo;
